import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  public displaySpinner = false;

  constructor() {
  }

  show() {
    this.displaySpinner = true;
  }

  hide() {
    this.displaySpinner = false;
  }

}
